import { ObservableArray, View } from "binder"
import { PersonSearchViewModel } from "../../personSearch-viewModel";
import { AttachmentListSelectorViewModel } from "../attachmentListSelector/attachmentListSelector-viewModel";
import { CreatePaymentRequestViewModel, reason } from "./createPaymentRequest-viewModel"

export class CreatePaymentRequestView extends View<CreatePaymentRequestViewModel>{
    GetViewUniqueId(): string {
        return "V-04AD0983-E352-4EA4-A479-6CF464E89278"
    }
    loadHtml(): string {
        let element = require('./createPaymentRequest.html').default;
        let style = require('./createPaymentRequest.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set personSelector(v: PersonSearchViewModel) { this._personSelector = v; } public get personSelector(): PersonSearchViewModel { return this._personSelector;} private _personSelector: PersonSearchViewModel;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount;} private _amount: number;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    public set reasons(v: ObservableArray<reason>) { this._reasons = v; } public get reasons(): ObservableArray<reason> { return this._reasons;} private _reasons: ObservableArray<reason>;
    public set selectedReason(v: reason) { this._selectedReason = v; } public get selectedReason(): reason { return this._selectedReason;} private _selectedReason: reason;
    public set attachments(v: AttachmentListSelectorViewModel) { this._attachments = v; } public get attachments(): AttachmentListSelectorViewModel { return this._attachments;} private _attachments: AttachmentListSelectorViewModel;
        
    public set selectedPersonId(v: string) { this._selectedPersonId = v; } public get selectedPersonId(): string { return this._selectedPersonId;} private _selectedPersonId: string;
    public set selectedPersonName(v: string) { this._selectedPersonName = v; } public get selectedPersonName(): string { return this._selectedPersonName;} private _selectedPersonName: string;
    public set selectedPersonCode(v: string) { this._selectedPersonCode = v; } public get selectedPersonCode(): string { return this._selectedPersonCode;} private _selectedPersonCode: string;
    
    async save(){
        this.dataContext.save();
    }
    close(){
        this.dataContext.closeWindow('no');
    }
}
